import { render, staticRenderFns } from "./Obstetrics.vue?vue&type=template&id=ba5bb7b8&scoped=true"
import script from "./Obstetrics.vue?vue&type=script&lang=js"
export * from "./Obstetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5bb7b8",
  null
  
)

export default component.exports